import { render, staticRenderFns } from "./RedirectToHome.vue?vue&type=template&id=616a63be&scoped=true&"
import script from "./RedirectToHome.vue?vue&type=script&lang=js&"
export * from "./RedirectToHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a63be",
  null
  
)

export default component.exports